import { render, staticRenderFns } from "./FileManagerContainer.vue?vue&type=template&id=88b5b4d4&scoped=true&"
import script from "./FileManagerContainer.vue?vue&type=script&lang=ts&"
export * from "./FileManagerContainer.vue?vue&type=script&lang=ts&"
import style0 from "./FileManagerContainer.vue?vue&type=style&index=0&id=88b5b4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b5b4d4",
  null
  
)

export default component.exports